import { render, staticRenderFns } from "./AnnualReportList.vue?vue&type=template&id=81375048&"
import script from "./AnnualReportList.vue?vue&type=script&lang=js&"
export * from "./AnnualReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports